FD.init = (function ($) {
    'use strict';

    const $pageHeader = $("#PAGE_HEADER");
    const sidebarOffset = 105 + ($pageHeader.length ? $pageHeader.height() : 0);

    /* ========================================================================
     *  init
     * ========================================================================
    */

    function init() {
        setupCustom$Events();
        bindLoader();

        // Setting datatable defaults
        $.extend($.fn.dataTable.defaults, {
            autoWidth: false,
            dom: '<"datatable-header"f<B>l><"datatable-scroll-wrap"t><"datatable-footer"ip>',
            buttons: {
                dom: {
                    button: {
                        className: 'btn btn-light'
                    }
                },
                buttons: [
                    'copyHtml5',
                    'excelHtml5',
                    'csvHtml5'
                    //'pdfHtml5' pdf doesn't work well with wide tables
                ]
            },
            language: {
                emptyTable: 'No results found :(',
                search: '<span>Filter:</span> _INPUT_',
                searchPlaceholder: 'Type to filter...',
                lengthMenu: '<span>Show:</span> _MENU_',
                paginate: { 'first': 'First', 'last': 'Last', 'next': $('html').attr('dir') === 'rtl' ? '&larr;' : '&rarr;', 'previous': $('html').attr('dir') === 'rtl' ? '&rarr;' : '&larr;' }
            },
            fixedHeader: {
                headerOffset: $('.fixed-top').height()
            },
            paging: true,
            responsive: {
                details: {
                    type: 'column',
                    target: -1
                }
            }
        });

        //fix select2 firefox issue -- https://select2.org/troubleshooting/common-problems
        $.fn.modal.Constructor.prototype._enforceFocus = function () { };

        $.fn.dataTable.moment('MM/DD/YYYY');
        $(document).enableControls();

        bsBreakpoints.init();
        if ($('#MAIN_SIDEBAR').length > 0) {
            handleStickySiderbar();
        }
        //handleStickySiderbar();
        handleDataTableLoading();
        $('form').dirtyForms({ message: "You have unsaved changes that may be lost if you leave this page. Are you sure you wish to proceed?", dialog: { title: 'Unsaved Changes' } });

        $(window).on('resize', debounce(() => {
            $($.fn.dataTable.tables(true)).DataTable().draw()
        }, 250))

        // on first focus (bubbles up to document), open the menu
        $(document).on('focus', '.select2-selection.select2-selection--single', function () {
            // Close any open datepickers
            $('.picker__input--active').each(function () {
                $(this).pickadate('picker').close();
            });
            $(this).closest(".select2-container").siblings('select:enabled').select2('open');
        });

        // steal focus during close - only capture once and stop propogation
        $('select.select2').on('select2:closing', function (e) {
            $(e.target).data("select2").$selection.one('focus focusin', function (e) {
                e.stopPropagation();
            });
        });

        document.cookie = "UserTimeZone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;

        $(document).on('focus', '.select-all', function () {
            $(this).select();
        });

        function setupCustom$Events() { // originated from needing someway to trigger our custom loading animation for unobtrusive ajax
            $.each(['show', 'hide'], function (i, ev) {
                const el = $.fn[ev];
                $.fn[ev] = function () {
                    const result = el.apply(this, arguments);
                    this.trigger(ev, arguments);
                    return result;
                };
            });

            $.propHooks.disabled = {
                set: function (el, value) {
                    if (el.disabled !== value) {
                        el.disabled = value;
                        value && $(el).trigger('disabled');
                        !value && $(el).trigger('enabled');
                    }
                }
            };
        }

        function bindLoader() {
            const progressBar = new Mprogress();

            $('#LOADER').bind('show', function () {
                progressBar.start();
            }).bind('hide', function () {
                progressBar.end();
            });

            $(document).bind('bind.dirtyforms', function (ev, events) {
                const originalBind = events.bind;

                events.bind = function (window, document, data) {
                    originalBind(window, document, data);
                    $(document).on('click', '.check-dirty', data, events.onAnchorClick);
                };
            });
        }
    }

    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    function handleStickySiderbar() {
        const currentbreakpoint = bsBreakpoints.getCurrentBreakpoint();
        if (currentbreakpoint !== "small" && currentbreakpoint !== "xSmall") {
            setSidebarSticky();
        } else {
            unstickSidebar();
        }

        //  set/unset sticky sidebar based on breakpoints... we want to unstick on small screens
        $(window).on('new.bs.breakpoint', function (e) {
            if (e.breakpoint !== "small" && e.breakpoint !== "xSmall") {
                setSidebarSticky();
            } else {
                if ($('body').hasClass('sidebar-xs')) {
                    $('.sidebar-main-toggle').trigger('click');
                }
                unstickSidebar();
            }
        });

        //  resize datatables when sidebar is hidden
        $('.sidebar-main-toggle').on('click', function () {
            $(window).trigger('resize');
            $.fn.dataTable
                .tables({ visible: true, api: true })
                .columns.adjust();
        });
    }


    function setSidebarSticky() {
        $('#MAIN_SIDEBAR').stick_in_parent({
            offset_top: sidebarOffset
        });
        $(".sidebar-content", '#MAIN_SIDEBAR').removeClass("position-absolute");
    }


    function unstickSidebar() {
        $('#MAIN_SIDEBAR').trigger("sticky_kit:detach");
        $(".sidebar-content", '#MAIN_SIDEBAR').addClass("position-absolute");
    }


    function handleDataTableLoading() {
        //  DataTables: show loading spinner and gray out the datatable parent card
        $(document).on('preXhr.dt', function (e) {
            var parentCard = e.target.closest('.card');
            if (parentCard !== null) {

                // TODO: ask Greg
                // me.blockUI(parentCard);
            }
        }).on('xhr.dt', function (e) {
            var parentCard = e.target.closest('.card');
            if (parentCard !== null) {
                // TODO: ask Greg
                // me.unblockUI(parentCard);
            }
        });
    }

    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    /* ========================================================================
     *  return
     * ========================================================================
    */

    return init;
}(jQuery));

// using to force validation of hidden inputs - does not work when in $(document).ready() -> https://stackoverflow.com/a/24752101/7328169
$.validator.setDefaults({ ignore: "" });